<template>
  <div>
    <div class="product-banner">
      <div class="product-header">
        {{ type == 'flexible' ? $t('flexibleHeader'): $t('fixedHeader') }}
      </div>
      <div class="product-container" v-if="currentProductExists">
        <div v-if="type == 'fixed'" class="product-list">
          <div class="form-item product-type">
            <span class="form-label">{{ $t('productType') }}</span>
            <md-radio-list
              ref="radio"
              :options="filteredProductTypeOptions"
              v-model="filter.productType"
              @input="updateCurrentProductId"
              icon=""
              icon-inverse=""
              icon-disabled=""
            ></md-radio-list>
          </div>
          <div class="form-item product-options" v-if="currentProductExists">
            <span class="form-label">{{ $t('periodLabel') }}</span>
            <md-radio-list
              ref="radio"
              :options="filteredProductList"
              v-model="filter.id"
              @input="updateCurrentProduct"
              icon=""
              icon-inverse=""
              icon-disabled=""
            ></md-radio-list>
          </div>
        </div>
        <div class="product-detail">
          <div class="detail-item">
            <div class="title">{{ $t('returnLabel') }}</div>
            <div class="content">{{ currentProduct.interestPercent }}%</div>
          </div>
          <div class="detail-item" v-if="type === 'flexible'">
            <div class="title">{{ $t('periodLabel') }}</div>
            <div class="content">None</div>
          </div>
          <div class="detail-item">
            <div class="title">{{ $t('minLabel') }}</div>
            <div class="content">
              {{ minInvestment | formatMoney }}
            </div>
          </div>
          <div class="detail-item" v-if="type === 'flexible'">
            <div class="title">{{ $t('maxLabel') }}</div>
            <div class="content">
              {{ flexibleRemainAmount | formatMoney }}
            </div>
          </div>
          <div class="detail-item">
            <div class="title">{{ $t('repayment') }}</div>
            <div class="content">
              {{ type === 'flexible' ? $t('flexiblePayment') : $t('fixedPayment') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <product-status-card :type="type" :flexibleRemainAmount="flexibleRemainAmount"></product-status-card>
  </div>
</template>

<script>
import { RadioList } from 'mand-mobile'
import ProductStatusCard from '@/components/product/ProductStatusCard'

export default {
  i18n: {
    messages: {
      en: {
        flexibleHeader: 'Flexible Investment',
        fixedHeader: 'Fixed Term Investment',
        kpInvestment: 'Funding',
        kpInvestmentVIP: 'Funding - VIP',
        idrProduct: 'IDR',
        productType: 'Product Type',
        repayment: 'Repayment',
        returnLabel: 'Return Projections',
        periodLabel: 'Lending Period',
        minLabel: 'Minimum amount',
        maxLabel: 'Maximum amount',
        DAY: 'days',
        fixedPayment: 'Full Payment After Completion Period',
        flexiblePayment: 'Withdraw Anytime',
        MONTH: 'month(s)',
        trialCard: 'Trial Card',
      },
      id: {
        flexibleHeader: 'Pendanaan Fleksibel',
        fixedHeader: 'Pendanaan Berjangka',
        kpInvestment: 'Pilihan Pendanaan',
        kpInvestmentVIP: 'Pilihan Pendanaan - VIP',
        idrProduct: 'IDR',
        periodLabel: 'Lama Periode',
        productType: 'Tipe Produk',
        repayment: 'Pelunasan',
        returnLabel: 'Proyeksi Keuntungan',
        minLabel: 'Pendanaan minimum',
        maxLabel: 'Pendanaan maximum',
        DAY: 'hari',
        fixedPayment: 'Pembayaran Penuh Setelah Periode Selesai',
        flexiblePayment: 'Tarik kapanpun',
        MONTH: 'bulan',
        trialCard: 'Kartu Coba',
      },
    },
  },
  components: {
    [RadioList.name]: RadioList,
    ProductStatusCard,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    const flexibleMaxAmount = 10000000
    return {
      currencyType: 'IDR',
      flexibleMaxAmount: flexibleMaxAmount,
      flexibleRemainAmount: flexibleMaxAmount,
      filter: {
        productType: 'kpInvestment',
        id: null,
      },
    }
  },
  computed: {
    loggedin() {
      return this.$store.getters.loggedin
    },
    locale() {
      return this.$store.state.locale
    },
    flexibleProduct() {
      return this.$store.state.flexibleProducts[0] || {}
    },
    fixedProductList() {
      const fixedProducts = this.$store.state.fixedProducts
      return fixedProducts.length ? fixedProducts.sort((a, b) => a.term - b.term) : []
    },
    trialProducts() {
      const trialProducts = this.$store.state.trialProducts || []
      return trialProducts.sort((a, b) => a.term - b.term)
    },
    newProducts() {
      const newProducts = this.$store.state.newProducts || []
      return newProducts.sort((a, b) => a.term - b.term)
    },
    commonProductList() {
      return this.trialProducts.concat(this.newProducts).concat(this.fixedProductList.filter(i => i.limitMinAmount < 1000000000))
    },
    vipProductList() {
      return this.fixedProductList.filter(i => i.limitMinAmount >= 1000000000)
    },
    filteredProductTypeOptions() {
      return this.vipProductList.length ? [
        { text: this.$t('kpInvestment'), value: 'kpInvestment' },
        { text: this.$t('kpInvestmentVIP'), value: 'kpInvestmentVIP' },
      ] : [{ text: this.$t('kpInvestment'), value: 'kpInvestment' }]
    },
    filteredProductList() {
      let list = {
        kpInvestment: this.commonProductList,
        kpInvestmentVIP: this.vipProductList,
      }[this.filter.productType]
      if (list) {
        list.forEach(i => {
          i.text = `${i.term} ${this.$t(i.dateUnit)}`
          i.value = i.id
        })
      }
      return list || []
    },
    currentProduct() {
      return this.$store.state.currentProduct
    },
    currentProductExists() {
      return Object.keys(this.currentProduct).length
    },
    minInvestment() {
      return this.currentProductExists ? this.currentProduct.limitMinAmount || 0 : 0
    },
  },
  async mounted() {
    await this.$store.dispatch('reloadInvestments')
    this.reloadCurrentProduct()
    if (this.type === 'flexible' && this.loggedin) {
      this.reloadFlexibleData()
    }
  },
  methods: {
    reloadCurrentProduct() {
      const { query } = this.$route
      if (Object.keys(query).length > 0) {
        this.filter = {
          productType: {
            common: 'kpInvestment',
            vip: 'kpInvestmentVIP',
          }[query.tag],
          id: query.investedId,
        }
        this.updateCurrentProduct()
      } else {
        this.updateCurrentProductId()
      }
    },
    updateCurrentProductId() {
      if (this.filter.productType === 'kpInvestment' && this.trialProducts.length) {
        const maxRate = Math.max(...this.trialProducts.map(i => i.interestPercent))
        const trialProduct = this.trialProducts.find(i => i.interestPercent === maxRate)
        this.filter.id = trialProduct.id
      } else if (this.filter.productType === 'kpInvestment' && this.newProducts.length) {
        const newMaxRate = Math.max(...this.newProducts.map(i => i.interestPercent))
        const newProduct = this.newProducts.find(i => i.interestPercent === newMaxRate)
        this.filter.id = newProduct.id
      } else if (this.filter.productType === 'kpInvestmentVIP') {
        const vipMaxRate = Math.max(...this.vipProductList.map(i => i.interestPercent))
        const vipProduct = this.vipProductList.find(i => i.interestPercent === vipMaxRate)
        this.filter.id = vipProduct.id
      } else {
        const maxInterestRate = Math.max(...this.commonProductList.map(i => i.interestPercent))
        const investment = this.commonProductList.find(i => i.interestPercent === maxInterestRate)
        this.filter.id = investment ? investment.id : ''
      }
      this.updateCurrentProduct()
    },
    updateCurrentProduct() {
      const product = this.type === 'fixed' ? this.filteredProductList.find(i => i.id === this.filter.id) : this.flexibleProduct
      this.$store.dispatch('updateCurrentProduct', product)
    },
    async reloadFlexibleData() {
      const res = await this.$http.get('/order/capital-and-revenue-sum')
      const flexibleData = res.data.data.flexibleOrder.find(i => i.currencyType === 'IDR') || { amountSum: 0 }
      this.flexibleRemainAmount = this.flexibleMaxAmount - flexibleData.amountSum
    },
  },
}
</script>

<style lang="stylus" scoped>
.product-banner {
  padding: 20px;
  background: color-primary;
  .product-header {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, .24);
  }
}

.product-list /deep/ {
  padding-top: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, .24);
  .form-item {
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    .form-label {
      color: #fff;
      display: inline-block;
      width: 100%;
      line-height: 32px;
      flex-shrink: 0;
    }
  }
  .product-type {
    .md-radio-item {
      width: auto;
    }
  }
  .product-options {
    .md-radio-item {
      width: 90px;
    }
  }
  .md-radio-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    .md-radio-item {
      color: #fff;
      border: 1px solid #fff;
      background: color-primary;
      border-radius: 4px;
      margin: 0 10px 10px 0;
      .md-cell-item-body {
        padding: 6px 15px;
        min-height: 34px;
        .md-cell-item-left {
          margin: 0;
        }
        .md-cell-item-content {
          font-size: 14px;
          color: #fff;
          text-align: center;
        }
      }
      &.is-selected {
        color: color-primary;
        background: #fff;
        .md-cell-item-content {
          color: color-primary;
        }
      }
    }
  }
}

.product-detail {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 20px 0;
  color: #fff;
  .detail-item {
    min-width: 40%;
    max-width: 100%;
    flex-grow: 1;
    margin-right: 10%;
    .title {
      font-size: 12px;
      line-height: 15px;
    }
    .content {
      margin: 8px 0 20px;
      font-size: 16px;
      line-height: 1.25em;
      font-weight: bold;
    }
  }
}

</style>
